import { render } from "./BerryTree.vue?vue&type=template&id=42fee1d5"
import script from "./BerryTree.vue?vue&type=script&lang=js"
export * from "./BerryTree.vue?vue&type=script&lang=js"

import "./BerryTree.vue?vue&type=style&index=0&id=42fee1d5&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__